module.exports = __webpack_public_path__ + "static/advrt-logo-c2a64c7aa2c9c793e22d627e1cdaede5.png";